export const initialState={
    basket:[]
};

//selector
export const getBasketTotal=(basket)=>
  basket?.reduce((amount,item)=> item.price+amount,0);

//action mean add or remove to basket
const reducer =(state,action)=>{
   //console.log(action)
    switch(action.type){
        case'ADD_TO_BASKET':
            return {
                 ...state,
                 basket:[...state.basket,action.item],
            }
        case "REMOVE_FROM_BASKET":
            const index =state.basket.findIndex(
                (basketItem) => basketItem.id===action.id
            );
            let newBasket=[...state.basket];
            if(index>=0){
               newBasket.splice(index,1);

            } else {
                console.warn(
                "Cant remove product (id: ${action.id})as its not in basket!"
                )
            }
            return {
                ...state,
                basket:newBasket
            }
           // return{
                //remove everthimg have that id
                // ...state,
                // basket:state.basket.filter(item=>
                //     item.id!==action.id)
            //}
        default:
            return state;
    }

}


export  default reducer;